export default __webpack_public_path__ + "static/media/Velocity.60ed6e4a.jpg";